<script>
    import NavigationHeader from '../NavigationHeader.vue';
    import AppDownload from '../shared/AppDownload.vue';
    
    export default {
        name: 'DownloadApp',
        components: {
            NavigationHeader,
            AppDownload
        },
    };
</script>

<template>
    <div class="container">
        <div id="download-app">
            <NavigationHeader route="/" navigationText="Zum Dashboard" title="Download App" />
            <AppDownload></AppDownload>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    
</style>
